import {init, TrackersNames, getTracker, trackEvent } from "@workiz/workiz-analytics-tracker";
import config from '../config';
import store from '../store';

// Initialize analytics with error handling
try {
  init({
    [TrackersNames.amplitude]: {
      apiKey: config.AMPLITUDE_API_KEY,
      options: {
        defaultTracking: false
      }
    }
  });
} catch (error) {
  console.warn('Analytics initialization failed, continuing without analytics', error);
}

function getPaymentSolution(gateway) {
  switch(gateway){
    case 'workiz-stripe':
      return 'stripe';
    case 'workiz':
      return 'wepay';
    default:
      return 'null';
  }
}

export function setExtraProperties() {
  try {
    const storeData = store.getState();
    const tracker = getTracker(TrackersNames.amplitude);
    if (tracker && typeof tracker.groupIdentify === 'function') {
      tracker.groupIdentify(storeData?.account?.accountId, {
        account_id: storeData?.account?.accountId,
        paymentSolution: getPaymentSolution(storeData?.account?.paymentSettings?.gateway),
        env: 'BookingV2'
      });
    }
  } catch (error) {
    console.warn('Failed to set extra properties for analytics', error);
  }
}

export function amplitudeEvent(eventName, props = {}) {
  try {
    trackEvent(TrackersNames.amplitude, eventName, props);
  } catch (error) {
    console.warn(`Failed to track event: ${eventName}`, error);
  }
}
